module.exports = __webpack_public_path__ + "img/ico-digital-platform_2.fef45956.svg";